import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationPets: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_643_3099"
        style={{ maskType: 'alpha' }}
        width="356"
        height="228"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 0h356v228H0V0z"></path>
      </mask>
      <g mask="url(#mask0_643_3099)">
        <path
          fill={colors.primary[50]}
          d="M337 161c0 88.366-71.634 160-160 160S17 249.366 17 161 88.634 1 177 1s160 71.634 160 160z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeLinejoin="round"
          strokeWidth="4"
          d="M177.912 38.675c-98.355 0-96.255 36.052-96.255 36.052v43.752s8.05-37.452 96.255-37.452 95.906 37.452 95.906 37.452V74.727s2.45-36.052-95.906-36.052z"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[500]}
          strokeLinejoin="round"
          strokeWidth="4"
          d="M177.913 105.879c-88.555 0-96.256-31.152-96.256-31.152v43.752s8.05 29.752 96.256 29.752c88.205 0 95.905-29.752 95.905-29.752V74.727s-7.35 31.152-95.905 31.152z"
        ></path>
        <path
          fill={colors.primary[100]}
          fillRule="evenodd"
          d="M136.26 145.431s-.169 3.796.701 5.95c1.166 2.891 3.216 4.444 6.3 4.901 9.45 1.4 21.701 2.45 35.352 2.45 6.65-1.05 18.551-5.601 18.551-17.151v-26.602c0-8.05-7.567-17.841-17.501-18.55-7.495-.536-12.715-.656-17.423-.763-4.528-.104-8.582-.197-13.729-.638-3.549-.304-7.157-.048-8.468 7.669 4.782.629 15.668 2.01 22.468 2.482 4.033.279 9.043.512 13.453.687 5.955.236 10.699 5.11 10.699 11.07v20.899c0 5.975-4.769 10.857-10.744 10.833-4.752-.019-10.277-.124-14.807-.437-7.602-.525-19.7-2.111-24.851-2.812l-.001.012z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M136.961 151.381l-1.855.749 1.855-.749zm-.701-5.95l-1.994-.154-.004.065 1.998.089zm7.001 10.851l-.293 1.978.293-1.978zm35.352 2.45v2c.104 0 .209-.008.312-.025l-.312-1.975zm1.05-62.304l.142-1.995-.142 1.995zm-17.423-.762l.045-2-.045 2zm-13.729-.638l.171-1.993-.171 1.993zm-8.468 7.669l-1.971-.335c-.091.536.04 1.085.362 1.523.323.437.81.724 1.349.795l.26-1.983zm22.468 2.482l.139-1.996-.139 1.996zm13.453.687l.079-1.999-.079 1.999zm-.045 42.802l-.008 2 .008-2zm-14.807-.437l.137-1.995-.137 1.995zm-24.851-2.812l.27-1.981a1.995 1.995 0 00-1.526.425 2.004 2.004 0 00-.738 1.402l1.994.154zm2.554 5.214c-.303-.752-.469-1.958-.534-3.144a24.418 24.418 0 01-.027-1.836l.003-.106a.248.248 0 00.001-.024l.001-.004v.001h-.001l-1.998-.089-1.998-.089v.019l-.002.04-.004.143a27.266 27.266 0 00.031 2.163c.068 1.251.253 3.02.819 4.423l3.709-1.497zm4.739 3.67c-1.276-.189-2.219-.585-2.939-1.141-.717-.554-1.326-1.354-1.8-2.529l-3.709 1.497c.692 1.715 1.692 3.137 3.063 4.197 1.368 1.057 2.991 1.665 4.799 1.933l.586-3.957zm35.059 2.429c-13.553 0-25.706-1.043-35.059-2.429l-.586 3.957c9.548 1.415 21.896 2.472 35.645 2.472v-4zm16.551-15.151c0 4.966-2.515 8.442-5.942 10.884-3.482 2.481-7.799 3.798-10.921 4.291l.624 3.951c3.528-.557 8.487-2.04 12.618-4.984 4.186-2.983 7.621-7.558 7.621-14.142h-4zm0-26.602v26.602h4v-26.602h-4zM179.52 98.423c4.34.31 8.257 2.616 11.121 5.853 2.879 3.255 4.523 7.262 4.523 10.703h4c0-4.609-2.14-9.523-5.527-13.353-3.404-3.848-8.237-6.793-13.832-7.193l-.285 3.99zm-17.326-.758c4.701.108 9.882.226 17.326.758l.285-3.99c-7.544-.539-12.804-.659-17.52-.767l-.091 4zm-13.854-.644c5.217.447 9.327.54 13.854.644l.091-3.999c-4.528-.103-8.525-.195-13.603-.63l-.342 3.985zm-6.325 6.011c.615-3.62 1.685-4.957 2.52-5.505.887-.582 2.047-.657 3.805-.506l.342-3.986c-1.79-.153-4.21-.251-6.341 1.148-2.184 1.432-3.573 4.081-4.269 8.179l3.943.67zm-2.232 1.648c4.771.627 15.718 2.018 22.59 2.494l.277-3.991c-6.729-.466-17.554-1.839-22.346-2.469l-.521 3.966zm22.59 2.494c4.063.281 9.096.515 13.512.69l.158-3.997c-4.404-.174-9.391-.406-13.393-.684l-.277 3.991zm13.512.69c4.896.194 8.778 4.2 8.778 9.072h4c0-7.048-5.606-12.791-12.62-13.069l-.158 3.997zm8.778 9.072v20.899h4v-20.899h-4zm0 20.899c0 4.899-3.901 8.852-8.736 8.833l-.016 4c7.115.029 12.752-5.783 12.752-12.833h-4zm-8.736 8.833c-4.739-.019-10.213-.124-14.678-.432l-.275 3.99c4.595.318 10.172.423 14.937.442l.016-4zm-14.678-.432c-7.524-.52-19.557-2.097-24.718-2.798l-.539 3.963c5.14.699 17.303 2.295 24.982 2.825l.275-3.99zm-24.989-.805l1.994.154h.001v-.002-.009l-3.988-.309v.009l-.001.002v.001l1.994.154z"
        ></path>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M131.36 144.381l-21.196-22.104a4 4 0 01.669-6.097l20.177-13.451"
        ></path>
        <circle
          cx="159.711"
          cy="126.53"
          r="5.7"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <circle
          cx="223.415"
          cy="121.63"
          r="5.7"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <circle
          cx="250.717"
          cy="115.329"
          r="5.7"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <circle
          cx="177.913"
          cy="173.432"
          r="5.7"
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <path
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M177.312 167.132L177.312 158.032"
        ></path>
        <mask id="path-14-inside-1_643_3099" fill="#fff">
          <path
            fillRule="evenodd"
            d="M173.414 201.254l23.855-5.948c2.13 6.335 8.807 10.07 15.404 8.425 6.94-1.731 11.164-8.759 9.433-15.699a12.94 12.94 0 00-8.328-9.107 12.938 12.938 0 003.078-11.95c-1.73-6.94-8.759-11.163-15.699-9.433-6.364 1.587-10.443 7.629-9.742 13.973l-24.001 5.984c-2.359-5.931-8.798-9.35-15.162-7.764-6.94 1.731-11.164 8.76-9.433 15.7a12.941 12.941 0 008.328 9.106 12.938 12.938 0 00-3.079 11.95c1.73 6.94 8.759 11.164 15.699 9.433 6.597-1.645 10.739-8.077 9.647-14.67z"
            clipRule="evenodd"
          ></path>
        </mask>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M173.414 201.254l23.855-5.948c2.13 6.335 8.807 10.07 15.404 8.425 6.94-1.731 11.164-8.759 9.433-15.699a12.94 12.94 0 00-8.328-9.107 12.938 12.938 0 003.078-11.95c-1.73-6.94-8.759-11.163-15.699-9.433-6.364 1.587-10.443 7.629-9.742 13.973l-24.001 5.984c-2.359-5.931-8.798-9.35-15.162-7.764-6.94 1.731-11.164 8.76-9.433 15.7a12.941 12.941 0 008.328 9.106 12.938 12.938 0 00-3.079 11.95c1.73 6.94 8.759 11.164 15.699 9.433 6.597-1.645 10.739-8.077 9.647-14.67z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M173.414 201.254l-.968-3.881-3.582.893.603 3.642 3.947-.654zm23.855-5.948l3.791-1.275-1.177-3.499-3.582.893.968 3.881zm16.509-16.381l-2.933-2.72-4.164 4.49 5.785 2.009 1.312-3.779zm-22.363-7.41l.967 3.881 3.393-.846-.385-3.475-3.975.44zm-24.001 5.984l-3.717 1.478 1.292 3.249 3.392-.846-.967-3.881zm-16.267 17.042l2.932 2.72 4.165-4.49-5.785-2.009-1.312 3.779zm23.234 10.594l23.856-5.947-1.936-7.763-23.855 5.948 1.935 7.762zm19.097-8.554c2.789 8.295 11.527 13.184 20.163 11.031l-1.935-7.762a8.953 8.953 0 01-10.646-5.819l-7.582 2.55zm20.163 11.031c9.084-2.265 14.611-11.465 12.346-20.548l-7.762 1.935a8.951 8.951 0 01-6.519 10.851l1.935 7.762zm12.346-20.548c-1.439-5.773-5.682-10.106-10.897-11.917l-2.624 7.557a8.938 8.938 0 015.759 6.295l7.762-1.935zm-9.276-5.418c3.754-4.048 5.466-9.866 4.027-15.639l-7.763 1.936a8.936 8.936 0 01-2.13 8.262l5.866 5.441zm4.027-15.639c-2.265-9.083-11.465-14.611-20.548-12.346l1.935 7.762a8.95 8.95 0 0110.85 6.52l7.763-1.936zm-20.548-12.346c-8.333 2.077-13.669 9.986-12.751 18.293l7.951-.879a8.954 8.954 0 016.735-9.652l-1.935-7.762zm-9.743 13.972l-24.001 5.985 1.935 7.762 24.001-5.984-1.935-7.763zm-19.317 8.387c-3.089-7.765-11.513-12.243-19.846-10.166l1.935 7.763a8.953 8.953 0 0110.478 5.36l7.433-2.957zm-19.846-10.166c-9.084 2.265-14.611 11.465-12.347 20.548l7.763-1.935a8.95 8.95 0 016.519-10.85l-1.935-7.763zm-12.347 20.548c1.44 5.773 5.682 10.106 10.897 11.917l2.625-7.557a8.938 8.938 0 01-5.759-6.295l-7.763 1.935zm13.012 19.122a8.943 8.943 0 012.13-8.263l-5.865-5.441c-3.754 4.048-5.466 9.866-4.027 15.639l7.762-1.935zm10.851 6.519a8.951 8.951 0 01-10.851-6.519l-7.762 1.935c2.265 9.084 11.464 14.611 20.548 12.346l-1.935-7.762zm6.667-10.135a8.951 8.951 0 01-6.667 10.135l1.935 7.762c8.636-2.153 14.056-10.572 12.625-19.205l-7.893 1.308z"
          mask="url(#path-14-inside-1_643_3099)"
        ></path>
      </g>
    </svg>
  );
};

export default IllustrationPets;
